import { Divider, TableList, Typography } from 'seagull';
import { NavLink } from 'react-router-dom';
import { routes } from "../../../constants";
import cn from 'classnames';
import styles from "./InvoiceDigestWidget.module.scss";
import React from 'react';
import { invoiceStatusToColor } from "./InvoicesDigestWidget";
import { InvoiceDigestStatus } from 'anchor-scout/types';
const renderCell = _ref => {
  let {
    value,
    testid
  } = _ref;
  return {
    value: /*#__PURE__*/React.createElement(Typography, {
      "data-testid": testid
    }, value)
  };
};
const renderDivider = () => /*#__PURE__*/React.createElement(Divider, {
  margin: 0
});
const renderHeaderItem = value => ({
  value: /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, value)
});
const {
  columnDefs,
  headerItems
} = (() => {
  const config = [{
    columnDef: {
      width: 300
    },
    headerItem: renderHeaderItem('Type')
  }, {
    columnDef: {
      width: 0
    },
    headerItem: renderHeaderItem('Invoices')
  }, {
    columnDef: {
      width: 100,
      hAlign: 'end'
    },
    headerItem: renderHeaderItem('Amount')
  }];
  return {
    columnDefs: config.map(i => i.columnDef),
    headerItems: config.map(i => i.headerItem)
  };
})();
const invoiceTypeToTypeCellText = type => {
  switch (type) {
    case InvoiceDigestStatus.RequiresClientApproval:
      return 'Requires client approval';
    case InvoiceDigestStatus.PaymentsVerificationRequired:
      return 'Payments verification required';
    case InvoiceDigestStatus.MissingPaymentMethod:
      return 'Missing payment method';
    case InvoiceDigestStatus.Failed:
      return 'Payment failed';
    case InvoiceDigestStatus.Disputed:
      return 'Payment disputed';
    case InvoiceDigestStatus.PaymentStopped:
      return 'Payment stopped';
  }
};
function InvoiceInfoRow(_ref2) {
  let {
    invoiceStatusGroup,
    invoiceType,
    testid,
    className,
    isLast
  } = _ref2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableList.Row, {
    disableMarginBottom: true,
    highlightOnHover: true,
    as: NavLink,
    size: "fluid",
    className: className,
    to: routes.invoicesDashboard,
    "data-testid": testid,
    items: [{
      value: /*#__PURE__*/React.createElement("div", {
        className: cn(styles.dotContainer)
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.dot,
        style: {
          background: invoiceStatusToColor[invoiceType]
        }
      }), /*#__PURE__*/React.createElement(Typography, null, invoiceTypeToTypeCellText(invoiceType)))
    }, renderCell({
      value: invoiceStatusGroup.count.toString()
    }), renderCell({
      value: invoiceStatusGroup.amount.display()
    })]
  }), !isLast && renderDivider());
}
const invoiceTypeToProps = invoiceType => {
  const map = {
    requiresClientApproval: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.requiresClientApproval()
    },
    paymentsVerificationRequired: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.paymentsVerificationRequired()
    },
    missingPaymentMethod: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.missingPaymentMethod()
    },
    failed: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.failed()
    },
    disputed: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.disputed()
    },
    paymentStopped: {
      invoiceToStatusGroup: invoicesDigest => invoicesDigest.paymentStopped()
    }
  };
  return map[invoiceType];
};
function InvoicesInfoTable(_ref3) {
  let {
    invoiceDigestModel
  } = _ref3;
  const invoicesInfoRowTestId = type => "invoices-digest-".concat(type, "-row");
  const className = invoiceDigestModel.invoicesTypeAmount() < 6 ? styles.lessThanSixItemsInvoiceInfoRow : styles.sixItemsInvoiceInfoRow;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "invoice-digest-table"
  }, /*#__PURE__*/React.createElement(TableList.Provider, {
    variant: "minimal",
    columnDefs: columnDefs,
    hPadding: "m"
  }, /*#__PURE__*/React.createElement(TableList.Header, {
    items: headerItems,
    bgColor: "transparent"
  }), renderDivider(), invoiceDigestModel.invoiceTypesToDisplay().map(invoiceType => {
    const props = invoiceTypeToProps(invoiceType);
    return /*#__PURE__*/React.createElement(InvoiceInfoRow, {
      key: invoiceType,
      testid: invoicesInfoRowTestId(invoiceType),
      invoiceType: invoiceType,
      invoiceStatusGroup: props.invoiceToStatusGroup(invoiceDigestModel),
      className: className
    });
  })));
}
export default InvoicesInfoTable;